import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import DirectionStack from './DirectionStack';
import ClientProvider from './client';
export default createDemo(import.meta.url, DirectionStack, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/components/stack/demos/direction/DirectionStack.tsx",
    "fileName": "DirectionStack.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Stack from '@mui/system/Stack';\nimport { styled } from '@mui/system';\n\nconst Item = styled('div')(({ theme }) => ({\n  backgroundColor: '#fff',\n  padding: theme.spacing(1),\n  textAlign: 'center',\n  borderRadius: 4,\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#262B32',\n  }),\n}));\n\nexport default function DirectionStack() {\n  return (\n    <div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Stack direction=\"row\" spacing={2}>\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n      </Stack>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 24,
        "focusedLines": 5,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Stack from '@mui/system/Stack';\nimport { styled } from '@mui/system';\n\nconst Item = styled('div')(({ theme }) => ({\n  backgroundColor: '#fff',\n  padding: theme.spacing(1),\n  textAlign: 'center',\n  borderRadius: 4,\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#262B32',\n  }),\n}));\n\nexport default function DirectionStack() {\n  return (\n    <div>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Stack direction=\"row\" spacing={2}>\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n      </Stack>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Stack"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "direction"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "row",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "spacing"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "2"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">Item 1</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">Item 2</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">Item 3</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Stack"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 24,
    "focusedLines": 5,
    "collapsible": true,
    "externals": [
      "@mui/system/Stack",
      "@mui/system"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
